import { render, staticRenderFns } from "./ContratoST.vue?vue&type=template&id=2006f142"
import script from "./ContratoST.vue?vue&type=script&lang=js"
export * from "./ContratoST.vue?vue&type=script&lang=js"
import style0 from "./ContratoST.vue?vue&type=style&index=0&id=2006f142&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports